<template>
    <div class="content-block">
        <div class="content-fields">
            <div class="header-text">
                <strong>Водитель</strong>
            </div>
            <div class="td-line text-content">
                <p  class="item-info">Фамилия:</p>
                <span class="item-info" >{{driver.first_name}} </span>
            </div>
            <div class="td-line text-content">
                <p  class="item-info">Имя:</p>
                <span class="item-info" >{{driver.last_name}} </span>
            </div>
            <div class="td-line text-content">
                <p  class="item-info">Отчество:</p>
                <span class="item-info" >{{driver.surname}} </span>
            </div>

            <div class="td-line text-content">
                <p class="item-info">Страна:</p>
                <span class="item-info" v-if="!redact">{{ countryLabel }}</span>
                <select v-else class="form-input" v-model="form.country">
                    <option v-for="item in countries" :key="item.code" :value="item.code">
                        {{ item.label }}
                    </option>
                </select>
            </div>
            <div class="td-line text-content">
                <p class="item-info">Телефон: </p>
                <span class="item-info" v-if="!redact">{{driver.phone}}</span>
                <input class="form-input" v-else type="" name="" v-model="form.phone">
            </div>
            <div class="td-line text-content">
                <p  class="item-info">Д/Р:</p>
                <span class="item-info"  v-if="!redact">{{driver.birthday}}</span>
            <input class="form-input" v-else type="" name="" v-model="form.birthday">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Пасспорт:</p>
                <span class="item-info"  v-if="!redact">{{driver.passport}}</span>
            <input class="form-input" v-else v-model="form.passport">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Кем выдан:</p>
                <span 
                class="item-info"  
                v-if="!redact">{{driver.passport_issued}}</span>
                <input 
                class="form-input" 
                v-else v-model="form.passport_issued">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Дата выдачи:</p>
                <span 
                class="item-info"  
                v-if="!redact">{{driver.passport_date}}</span>
                <input 
                class="form-input" 
                v-else v-model="form.passport_date">
            </div>
            <div class="td-line text-content">
                <p  class="item-info">ВУ:</p>
                <span class="item-info"  v-if="!redact">{{driver.license}}</span>
                <input class="form-input" v-else v-model="form.license">
            </div>
            <div class="td-line text-content">
                <p class="item-info">ИНН: </p>
                <input class="form-input" v-if="redact" v-model="form.inn">
                <span class="item-info" v-else>{{driver.inn}}</span>
                <template v-if="!redact">
                    <span v-if="isInnActive" class="inn-badge inn-badge-pending" title="Проверка в ФНС">⏳</span>
                    <span v-else-if="driver.inn_check_status === 'done' && driver.inn" class="inn-badge inn-badge-success" title="Получен из ФНС">✓</span>
                    <span v-else-if="driver.is_random_inn" class="inn-badge inn-badge-warning" title="Сгенерирован случайно">⚠</span>
                    <span v-else-if="driver.inn_check_status === 'failed'" class="inn-badge inn-badge-error" :title="driver.inn_check_error || 'Не удалось проверить'">✗</span>
                    <button
                        class="inn-recheck-icon"
                        :disabled="isInnActive"
                        :title="isInnActive ? 'Идёт проверка' : 'Перепроверить ИНН'"
                        @click="$emit('recheck', driver.id)"
                    >↻</button>
                </template>
            </div>
            <div v-if="driver.is_random_inn" class="text-content">
                <p style="color:red;">Инн сгенерирован случайно</p>
            </div>
        </div>
        <div class="content-buttons">
            <div class="tms-status">
                <security-status-label v-if="driver.security_status" class="status-label" :status="driver.security_status"/>
                <div v-else-if="!driver.tms_id" class="error-msg"><p>TMS ID еще не получен</p></div>
            </div>
            <p v-if="saveError" class="error-msg">{{ saveError }}</p>
            <div class="button-container" v-if="!redact">
                <button class="redact-btn" @click="openClose">Изменить</button>
            </div>
            <div v-else class="button-container">
                <button class="redact-btn" @click="openClose">Отмена</button>
                <button class="redact-btn" @click="saveForm">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import { saveExecutorForm } from '@/pages/trip/helpers/saveExecutorForm.mjs'
import { ref, computed } from 'vue'
import {
  CIS_COUNTRIES,
  licenseByCountry,
  passportByCountry,
  phoneByCountry,
} from '@/constants/cisCountries.mjs'

export default {
  name: 'CardDriverExecitor',
  props: ['driver'],
  emits: ['updateExecutor', 'recheck'],
  setup(props,{emit}){
    const redact = ref(false)
    const saveError = ref('')
    const form = ref({
        id:props.driver.id,
        country: props.driver.country || 'RU',
        phone:props.driver.phone,
        birthday:props.driver.birthday,
        passport:props.driver.passport,
        license:props.driver.license,
        inn:props.driver.inn,
        passport_issued:props.driver.passport_issued,
        passport_date:props.driver.passport_date,
    })

    const countries = CIS_COUNTRIES
    const countryLabel = computed(() => {
      const code = props.driver.country || 'RU'
      return CIS_COUNTRIES.find((item) => item.code === code)?.label || code
    })

    const isInnActive = computed(() =>
      ['pending', 'processing'].includes(props.driver.inn_check_status)
    )
    

    const saveForm = async () =>{
      const country = form.value.country || 'RU'
      const asError = (result) => (result === true ? '' : result)
      const message = asError(phoneByCountry(form.value.phone, country))
        || asError(passportByCountry(form.value.passport, country))
        || asError(licenseByCountry(form.value.license, country))
      if (message) {
        saveError.value = message
        return
      }
      saveError.value = ''
      const saved = await saveExecutorForm(emit, { form: form.value, model: 'drivers' })
      if (!saved) return
      redact.value = false
    }

    
    const openClose = () =>{
        redact.value = !redact.value
        saveError.value = ''
        if (redact.value) {
          form.value = {
            id: props.driver.id,
            country: props.driver.country || 'RU',
            phone: props.driver.phone,
            birthday: props.driver.birthday,
            passport: props.driver.passport,
            license: props.driver.license,
            inn: props.driver.inn,
            passport_issued: props.driver.passport_issued,
            passport_date: props.driver.passport_date,
          }
        }
    }

    return{
     openClose,
     redact,
     saveForm,
     form,
     isInnActive,
     countries,
     countryLabel,
     saveError,
    }
  }
};
</script>

<style scoped>

.content-block{
  border: 1px solid #ccc;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.content-fields{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
}

.content-buttons{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.status-label{
  margin-bottom: 20px;
}

.td-line{
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.text-content{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 15px ;
}

.item-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
}


.form-input{
  padding: 2px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-bottom: 3px;
  width: 160px;
}

.tms-status{
    margin-top: 15px;
    width: 100%;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redact-btn {
  padding: 4px;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.header-text{
    padding: 5px;
    margin-top: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: rgba(204, 204, 204, 0.5);
}

.error-msg{
  text-align: center;
  color: rgba(255,105,116, 1.0);
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 3px;
}

.inn-badge {
  margin-left: 6px;
  font-size: 14px;
  line-height: 1;
}

.inn-badge-success { color: #28a745; }
.inn-badge-warning { color: #ffc107; }
.inn-badge-error   { color: #dc3545; }
.inn-badge-pending { color: #ffc107; }

.inn-recheck-icon {
  margin-left: 6px;
  padding: 0 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
}

.inn-recheck-icon:disabled {
  color: #ccc;
  cursor: not-allowed;
}
</style>
